import React from 'react';
import { Col, Row } from "antd";
import { InputToolItem } from './InputToolItem';
import { DirectionEnum } from '../../../enums';
import { tTable } from '../../../assets/libs/i18n/translator';

const RECT_TABLE_SEAT_DIRECTIONS = [
    { label: tTable("seatsUp"), key: DirectionEnum.Up },
    { label: tTable("seatsDown"), key: DirectionEnum.Down },
    { label: tTable("seatsLeft"), key: DirectionEnum.Left },
    { label: tTable("seatsRight"), key: DirectionEnum.Right },
];

const RECT_TABLE_DIMENSIONS = [
    { label: tTable("tableHeight"), key: "height" },
    { label: tTable("tableWidth"), key: "width" },
];

const RectTableDefaultPropertiesPanel = ({
    rectTableSeats,
    rectTableSeatsHandler,
    rectTableDimensions,
    rectTableDimensionsHandler,
}) => {

    return (
        <Row>
            <Col span={24} className="mb-2">
                <h3>{tTable("rectTableConfig")}</h3>
            </Col>

            {RECT_TABLE_SEAT_DIRECTIONS.map((item) => (
                <InputToolItem
                    key={item.key}
                    label={item.label}
                    value={rectTableSeats[item.key]}
                    onChange={(value) => rectTableSeatsHandler(item.key, value)}
                />
            ))}

            {RECT_TABLE_DIMENSIONS.map((item) => (
                <InputToolItem
                    key={item.key}
                    label={item.label}
                    value={rectTableDimensions[item.key]}
                    onChange={(value) => rectTableDimensionsHandler(item.key, value)}
                />
            ))}
        </Row>
    );
}

export { RectTableDefaultPropertiesPanel };